export const CopyIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.40065 15.1663H4.60065C1.99398 15.1663 0.833984 14.0063 0.833984 11.3997V8.59967C0.833984 5.99301 1.99398 4.83301 4.60065 4.83301H7.40065C10.0073 4.83301 11.1673 5.99301 11.1673 8.59967V11.3997C11.1673 14.0063 10.0073 15.1663 7.40065 15.1663ZM4.60065 5.83301C2.53398 5.83301 1.83398 6.53301 1.83398 8.59967V11.3997C1.83398 13.4663 2.53398 14.1663 4.60065 14.1663H7.40065C9.46732 14.1663 10.1673 13.4663 10.1673 11.3997V8.59967C10.1673 6.53301 9.46732 5.83301 7.40065 5.83301H4.60065Z"
        fill="#4A5368"
      />
      <path
        d="M11.4007 11.1663H10.6673C10.394 11.1663 10.1673 10.9397 10.1673 10.6663V8.59967C10.1673 6.53301 9.46732 5.83301 7.40065 5.83301H5.33398C5.06065 5.83301 4.83398 5.60634 4.83398 5.33301V4.59967C4.83398 1.99301 5.99398 0.833008 8.60065 0.833008H11.4007C14.0073 0.833008 15.1673 1.99301 15.1673 4.59967V7.39967C15.1673 10.0063 14.0073 11.1663 11.4007 11.1663ZM11.1673 10.1663H11.4007C13.4673 10.1663 14.1673 9.46634 14.1673 7.39967V4.59967C14.1673 2.53301 13.4673 1.83301 11.4007 1.83301H8.60065C6.53398 1.83301 5.83398 2.53301 5.83398 4.59967V4.83301H7.40065C10.0073 4.83301 11.1673 5.99301 11.1673 8.59967V10.1663Z"
        fill="#4A5368"
      />
    </svg>
  );
};
